import {createEpicTheme} from '@epic-ui/theme';

export const theme = createEpicTheme({
    palette: {type: 'dark'},
    overrides: {
        MuiTooltip: {
            tooltip: {
                backgroundColor: '#4c4c4e'
            },
            arrow: {
                color: '#4c4c4e'
            }
        }
    }
});
